import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup,  ReactiveFormsModule,  Validators } from '@angular/forms';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-grade-master',
  imports: [CommonModule,ReactiveFormsModule,MatModule,MatPaginatorModule],
  templateUrl: './grade-master.component.html',
  styleUrl: './grade-master.component.scss'
})
export class GradeMasterComponent {
 dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','grade','min_mark','max_mark','grade_point','subject_type','current_grade','createdAt'],
   cols: ['sno','grade','min_mark','max_mark','grade_point','subject_type','current_grade','createdAt'],
  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;

 GradeId: string | null = null;
 
 isGradeList=false;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
   private exportService: ExportService
 ) {
   this.formGroup = this.fb.group({
    grade: ['', [Validators.required]],
    min_mark: ['', [Validators.required]],
    max_mark: ['', [Validators.required]],
    grade_point: ['', [Validators.required]],
    subject_type: ['', [Validators.required]],
    current_grade: ['', [Validators.required]],
   });
 }

 ngOnInit(): void {
  
   this.getGradeList();
 }

 getGradeList_download(): void {
  this.api.get(`settings/getGradeList`).subscribe({
    next: (response) => {
    
      if (response && response.data && response.data.length > 0) {

        this.dataSource = response.data;
        this.pagination.length = response?.totalCount || 0;
        const exportPayload = {
          filename: 'grade-list',
          displayedColumns: this.displayedColumns.cols,
          data: this.dataSource,
          dateField:['createdAt'],
          isDateMultiply:false
        };
        this.exportService.exportExcel(exportPayload);
      } else {
        console.log('No settings found or empty settings array');
      }
      this.isLoading = false;
    },
    error: (error) => {
      console.error('Error fetching settings information:', error);
      this.common.notification('Error loading settings information', true);
      this.isLoading = false;
    }
  });
}

 getGradeList(): void {
   this.isGradeList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getGradeList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No settings found or empty settings array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching settings information:', error);
       this.common.notification('Error loading settings information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isGradeList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isGradeList=false;   
   this.GradeId=row.id;
   this.isEdit=true;
   this.formGroup.patchValue({
    grade: row.grade,
    min_mark: row.min_mark,
    max_mark: row.max_mark,
    grade_point: row.grade_point,
    subject_type: row.subject_type,
    current_grade:row.current_grade,
   });
 }
   


 saveGrade(): void {
   this.isGradeList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   if (this.GradeId) {
        
     this.api.put(`settings/updateGrade/${this.GradeId}`, formData).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/addGrade`,formData,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getGradeList();
     this.resetForm();
   }
 }
 



 addGrade(){
   this.isLoading=false;
   this.resetForm();
   this.isGradeList=false;
 }
 


back(){
 this.isEdit=false;
 this.isGradeList=true;  
 this.resetForm();
 this.GradeId=null;
 this.getGradeList();
}

delete(row:any)
{

 const GradeId=row.id;
 this.api.put(`settings/deleteGrade/${GradeId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getGradeList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getGradeList();
}
}
